import { render, staticRenderFns } from "./NewMenu.vue?vue&type=template&id=651e3a36&scoped=true&"
import script from "./NewMenu.vue?vue&type=script&lang=js&"
export * from "./NewMenu.vue?vue&type=script&lang=js&"
import style0 from "./NewMenu.vue?vue&type=style&index=0&id=651e3a36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651e3a36",
  null
  
)

export default component.exports